import { Pipe, PipeTransform } from '@angular/core';
import { LANDING_GEM } from '../data';
import { LandingGemFacetInterface } from '../types';

type GemPoint = [number, number];

@Pipe({ name: 'landingGemFacets' })
export class LandingGemFacetsPipe implements PipeTransform {
  transform(rotation: number): LandingGemFacetInterface[] {
    const step = (Math.PI * 2) / LANDING_GEM.facets;
    const culet: GemPoint = [LANDING_GEM.culet.x, LANDING_GEM.culet.y];
    const facets: LandingGemFacetInterface[] = [];

    for (let index = 0; index < LANDING_GEM.facets; index++) {
      const start = rotation + index * step;
      const middle = start + step / 2;
      const girdleStart = this.girdlePoint(start);
      const girdleEnd = this.girdlePoint(start + step);
      const table = this.tablePoint(middle);
      const tablePrevious = this.tablePoint(middle - step);

      if (Math.cos(middle) > 0) {
        facets.push(
          this.facet(
            [girdleStart, girdleEnd, table],
            0.4 + 0.6 * this.light(middle),
          ),
          this.facet(
            [girdleStart, girdleEnd, culet],
            0.1 + 0.6 * this.light(middle + 0.5),
          ),
        );
      }

      if (Math.cos(start) > 0) {
        facets.push(
          this.facet(
            [tablePrevious, table, girdleStart],
            0.5 + 0.5 * this.light(start),
          ),
        );
      }
    }

    return facets;
  }

  private girdlePoint(angle: number): GemPoint {
    return [
      LANDING_GEM.center + LANDING_GEM.girdle.radius * Math.sin(angle),
      LANDING_GEM.girdle.y,
    ];
  }

  private tablePoint(angle: number): GemPoint {
    return [
      LANDING_GEM.center + LANDING_GEM.table.radius * Math.sin(angle),
      LANDING_GEM.table.y,
    ];
  }

  private light(angle: number): number {
    const light = 0.5 + 0.5 * Math.cos(angle - LANDING_GEM.lightAngle);

    return light * light;
  }

  private facet(points: GemPoint[], level: number): LandingGemFacetInterface {
    return {
      points: points
        .map(([x, y]) => `${x.toFixed(2)},${y.toFixed(2)}`)
        .join(' '),
      fill: this.color(level),
    };
  }

  private color(level: number): string {
    const bright = level > LANDING_GEM.goldLevel;
    const from = bright ? LANDING_GEM.goldRgb : LANDING_GEM.shadowRgb;
    const to = bright ? LANDING_GEM.shineRgb : LANDING_GEM.goldRgb;
    const mix = bright
      ? (level - LANDING_GEM.goldLevel) / (1 - LANDING_GEM.goldLevel)
      : level / LANDING_GEM.goldLevel;
    const rgb = from.map((channel, index) =>
      Math.round(channel + (to[index] - channel) * mix),
    );

    return `rgb(${rgb.join(',')})`;
  }
}
